export default function Action() {
  return (
    <section className="text-center action">
      <div className="col-sm-8 offset-md-2">
        <h1 className="display-3 pb-5">End with one final call to action</h1>
        <p className="h3 pb-5">
          This is your last shot at converting someone. Remind them about the
          benefits of your offer and encourage them to act now.
        </p>
        <button type="button" className=" btn btn-warning">
          ORDER NOW
        </button>
      </div>
    </section>
  );
}
